export enum QuizType {
    Personality = 0,
    Challenge = 1,
    ChallengeReveal = 2,
    Slider = 3,
}
